namespace TabAurous.Stock {
    export namespace StockItemBOMService {
        export const baseUrl = 'Stock/StockItemBOM';

        export declare function Create(request: Serenity.SaveRequest<StockItemBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<StockItemBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockItemBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetStockBOM(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Stock/StockItemBOM/Create",
            Update = "Stock/StockItemBOM/Update",
            Delete = "Stock/StockItemBOM/Delete",
            Retrieve = "Stock/StockItemBOM/Retrieve",
            List = "Stock/StockItemBOM/List",
            GetStockBOM = "Stock/StockItemBOM/GetStockBOM"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetStockBOM'
        ].forEach(x => {
            (<any>StockItemBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
